import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { HOME_BASE_URL } from 'constants/locations';
import { MarketOddsBannerLocationTypes } from 'constants/markets';
import { getIsShowMarketOdd, getMarketOddsBannerLocation } from 'redux/modules/appConfigs/selectors';
import {
  getArePopularMarkets,
  getIsFeatureMarketsSportIdsIncludesPopularMarketsSportId,
  getPopularMarketsSportId
} from 'redux/modules/popularMarket/selectors';

const useShowMarketOddOnPage = () => {
  const { sportId } = useParams();
  const location = useLocation();

  const marketSportId = useSelector(getPopularMarketsSportId);
  const arePopularMarkets = useSelector(getArePopularMarkets);
  const isFeatureMarketsSportIdsIncludesPopularMarketsSportId = useSelector(
    getIsFeatureMarketsSportIdsIncludesPopularMarketsSportId
  );
  const marketOdds = useSelector(getIsShowMarketOdd);
  const marketOddsBannerLocation = useSelector(getMarketOddsBannerLocation);

  let isShowOnPage = marketOddsBannerLocation === MarketOddsBannerLocationTypes.ALL;

  if (marketOddsBannerLocation === MarketOddsBannerLocationTypes.HOME) {
    isShowOnPage = location.pathname === HOME_BASE_URL;
  }

  if (marketOddsBannerLocation === MarketOddsBannerLocationTypes.SPORT) {
    isShowOnPage =
      location.pathname === HOME_BASE_URL
        ? isFeatureMarketsSportIdsIncludesPopularMarketsSportId
        : marketSportId === sportId;
  }

  return arePopularMarkets && marketOdds && isShowOnPage;
};

export default useShowMarketOddOnPage;
